// 基础类
import '../common/m_base/errorReporter'
import '../common/m_base/autoAdjustRem'
import '../common/m_base/index'
import '../common/m_common/index'

// API list
import "./m/bt/bigTplAPIList"

// 二选一模板
import "./m/bt/bigTplChoseFromTwo"

// lf
import "./m/bt/bigTplChooseFromTwoLegacy"

// case demo
import "./m/bt/bigTplCaseDemo"
import "./m/vt/videoTplNative"
import "./m/vt/videoTplH5"
import "./m/ect/endcardTplNative"
import "./m/miniect/miniEndcardTplNative"